/**
 * Opportunity API service
 */
import api from './api';

export const opportunityApi = {
  /** Fetch opportunities (with optional filters) */
  getOpportunities: (params = {}) =>
    api.get('/opportunities', { params }).then(r => r.data),

  /** Get auto-generated dealer profile */
  getDealerProfile: () =>
    api.get('/opportunities/profile').then(r => r.data),

  /** Get personalized preview (for conversion page) */
  getPreview: () =>
    api.get('/opportunities/preview').then(r => r.data),

  /** Request access to opportunities */
  requestAccess: () =>
    api.post('/opportunities/request-access').then(r => r.data),

  /** Force refresh from AutoLink */
  refreshOpportunities: () =>
    api.post('/opportunities/refresh').then(r => r.data),

  /** Dismiss an opportunity */
  dismissOpportunity: (id) =>
    api.post(`/opportunities/${id}/dismiss`).then(r => r.data),

  /** Save an opportunity */
  saveOpportunity: (id) =>
    api.post(`/opportunities/${id}/save`).then(r => r.data),

  /** Send feedback on an opportunity */
  sendFeedback: (id, { rating, tags = [], comment = null, vehicle_snapshot = null }) =>
    api.post(`/opportunities/${id}/feedback`, { rating, tags, comment, vehicle_snapshot }).then(r => r.data),
};
